// Company Information - Centralized Data
// Update this file to change company details across the entire website

export const companyInfo = {
    name: 'Phoenix Ai Sdn Bhd',
    tagline: 'Enterprise AI Solutions',
    
    // Contact Details
    email: 'info@phoenixai.my',
    phone: '03-8408 8103',
    
    // Office Address
    address: {
        line1: 'M2-05-05, Menara 2, 8Trium',
        line2: 'Jalan Cempaka SD 12/5',
        line3: 'Bandar Sri Damansara',
        city: 'Kuala Lumpur',
        postcode: '52200',
        country: 'Malaysia',
        full: 'M2-05-05, Menara 2, 8Trium, Jalan Cempaka SD 12/5, Bandar Sri Damansara, 52200, Kuala Lumpur',
    },
    
    // Social Media Links
    social: {
        linkedin: 'https://www.linkedin.com/company/phoenixai-solutions',
        facebook: 'https://www.facebook.com/phoenixai.my',
        instagram: 'https://www.instagram.com/phoenixaisdnbhd/',
        tiktok: 'https://tiktok.com/@phoenixaisolutions',
    },
    
    // WhatsApp
    whatsapp: {
        number: '60123773589', // Without + or spaces for wa.me link
        message: 'Hello! I would like to know more about Phoenix AI services.',
    },
    
    // Business Hours
    businessHours: {
        weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
        weekend: 'Closed',
        timezone: 'MYT (GMT+8)',
    },
    
    // Google Maps Embed URL
    // To update: Go to Google Maps → Search location → Share → Embed a map → Copy src URL
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.6062614331745!2d101.6099368!3d3.1976815999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc45fc19338679%3A0xf7007d8578f4cc5c!2sMenara%208trium!5e0!3m2!1sen!2smy!4v1768332318302!5m2!1sen!2smy',
};

export default companyInfo;
